/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for user activity status.
 * @export
 * @interface UserActivityStatus
 */
export interface UserActivityStatus {
  /**
   *
   * @type {Array<string>}
   * @memberof UserActivityStatus
   */
  activeUsernames: Array<string>;
  /**
   *
   * @type {number}
   * @memberof UserActivityStatus
   */
  activeSessionsCount: number;
  /**
   *
   * @type {boolean}
   * @memberof UserActivityStatus
   */
  hasActiveUsers: boolean;
}

/**
 * Check if a given object implements the UserActivityStatus interface.
 */
export function instanceOfUserActivityStatus(value: object): value is UserActivityStatus {
  if (!('activeUsernames' in value) || value['activeUsernames'] === undefined) return false;
  if (!('activeSessionsCount' in value) || value['activeSessionsCount'] === undefined) return false;
  if (!('hasActiveUsers' in value) || value['hasActiveUsers'] === undefined) return false;
  return true;
}

export function UserActivityStatusFromJSON(json: any): UserActivityStatus {
  return UserActivityStatusFromJSONTyped(json, false);
}

export function UserActivityStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserActivityStatus {
  if (json == null) {
    return json;
  }
  return {
    activeUsernames: json['active_usernames'],
    activeSessionsCount: json['active_sessions_count'],
    hasActiveUsers: json['has_active_users'],
  };
}

export function UserActivityStatusToJSON(value?: UserActivityStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    active_usernames: value['activeUsernames'],
    active_sessions_count: value['activeSessionsCount'],
    has_active_users: value['hasActiveUsers'],
  };
}
